import { Box, Radio, Tab, Tabs } from '@mui/material'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { focusElemnt, isEmpty } from '../../../common/helper'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import { getOwnChildUsers, getFranchiseeBranchList, getCompanyList } from '../../../../store/reports/reports_action'
import DeliveryOwnCompanyNew from './DeliveryOwnCompany/DeliveryOwnCompanyNew'
import DeliveryFranchiseeCompanyNew from './DeliveryFranchiseeCompany/DeliveryFranchiseeCompanyNew'
import useToken from '../../../helpers/useTokens'
import { styled } from '@mui/system'

const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: 4,
    backgroundColor: theme.palette.primary.main,
  },
}))

const deliveryTabs = [
  { id: 0, name: 'OWN DELIVERIES' },
  { id: 1, name: 'Franchisee Deliveries' },
]

const tabSx = {
  minHeight: '30px',
  height: '35px',
  flex: 1,
  maxWidth: '150px',
  padding: '5px 12px',
  position: 'relative',

  '&.Mui-selected::after': {
    content: '""',
    position: 'absolute',

    left: '6px',
    right: '6px',

    bottom: '0px',
    height: '4px',
    backgroundColor: '#0086ff',
  },
}

const DeliveryReport = (props) => {
  const {
    data: { common, reports },
    getOwnChildUsers,
    getFranchiseeBranchList,
  } = props

  const { franchiseeCompany } = reports
  const [selectedRadio, setSelectedRadio] = useState('OwnCompany')
  const [selBranch, setSelBranch] = useState()
  const [selFrCompany, setSelFrCompany] = useState()
  const [selectedTab, setSelectedTab] = useState(0)

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    isFromUrl = true
  }
  const { intCompanyID, intBranchID, intUserID, strBranchName } = loginData

  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intCompanyID: intCompanyID,
        intIsActive: -1,
      }
      setSelBranch({ BranchName: strBranchName, BranchID: intBranchID })
      getOwnChildUsers(branchData)
      const companylistData = {
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        intMode: 1,
      }
      getCompanyList(companylistData)
    }
  }, [intUserID])
  useEffect(() => {
    if (franchiseeCompany && franchiseeCompany.length) {
      setSelFrCompany(franchiseeCompany[0])
      getFranchiseeBranch(franchiseeCompany[0])
    }
  }, [franchiseeCompany])

  const getFranchiseeBranch = (company) => {
    const data = {
      intCompanyID: intCompanyID,
      intUserID: intUserID,
      intFranchiseeCompanyID: company.CompanyID,
    }
    getFranchiseeBranchList(data)
  }

  const reportName = 'Delivery'
  const handleChange = (e) => {
    setSelectedRadio(e.target.value)
    focusElemnt(id.fromDate)
  }
  return (
    <>
      <Box sx={{ padding: '0' }} className="reports" >
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        {!isFromUrl && (
          <Box className="radio-wrap" sx={{ paddingLeft: '15px', paddingRight: '24px', display: 'flex', borderBottom: '1px solid #ccc !important', fontSize: '14px', gap: "16px" }}>
            <label htmlFor={'isCrossingRadioYes'} className="radio-label flex">
              <Radio
                id={'isCrossingRadioYes'}
                name={`isCrossingRadio`}
                size={'medium'}
                value="OwnCompany"
                checked={selectedRadio === 'OwnCompany'}
                onChange={handleChange}
              />
              OWN DELIVERIES
            </label>
            <label htmlFor={'isCrossingRadioNo'} className="radio-label flex">
              <Radio
                id={'isCrossingRadioNo'}
                name={`isCrossingRadio`}
                size={'medium'}
                value="FranchiseCompany"
                checked={selectedRadio === 'FranchiseCompany'}
                onChange={handleChange}
              />
              Franchisee Deliveries
            </label>
          </Box>)}
        {isFromUrl && (
          <Box>
            <StyledTabs
              value={selectedTab}
              onChange={handleTabChange}
              sx={{
                backgroundColor: '#e5f3fe', height: '30px', minHeight: '37px', border: 'none', padding: '0 24px',
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }}
            >
              {deliveryTabs.map((tab) => (
                <Tab
                  key={tab.id}
                  label={tab.name}
                  sx={{ ...tabSx, padding: '5px 5px' }}
                />
              ))}
            </StyledTabs>
          </Box>
        )}
      </Box>
      {isFromUrl ? (
        <>
          {selectedTab === 0 && <DeliveryOwnCompanyNew />}
          {selectedTab === 1 && <DeliveryFranchiseeCompanyNew />}
        </>
      ) : (
        <>
          {selectedRadio === 'OwnCompany' && <DeliveryOwnCompanyNew />}
          {selectedRadio === 'FranchiseCompany' && <DeliveryFranchiseeCompanyNew />}
        </>
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnChildUsers, getFranchiseeBranchList }
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryReport)
